import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { OSDReferences } from 'mirador/dist/es/src/plugins/OSDReferences';
import { getSequence, getCurrentCanvas, getManifest, getManifestTitle, getCanvases } from 'mirador/dist/es/src/state/selectors';
import {SanitizedHtml} from 'mirador/dist/es/src/components/SanitizedHtml';
import OpenSeadragon from 'openseadragon';

function isPageNumber(str) {
    return /^\d+[a-zA-Z]*$/.test(str);
}

function EnhanceDescription({ canvasElement, canvasLabel, itemTitle, fullyInView, description, multipage }) {
    // make a random but semi-persistent id for our hidden element that we need to refer to by id in aria-describedby
    const [descriptionId] = useState(() => {
        return `osd-desc-${Math.random().toString(36).substring(2, 10)}`;
    });
    useEffect(() => {
        if (!canvasElement) return;

        let label = `${itemTitle}`;
        if (multipage) label = `${isPageNumber(canvasLabel) ? `Page ${canvasLabel}` : canvasLabel}, ${label}`;
        if (fullyInView === false) label = `Cropped region from ${label}`;

        canvasElement.setAttribute('aria-label', label);
        if (description) canvasElement.setAttribute('aria-describedby', descriptionId);
        canvasElement.innerHTML = label;
    }, [canvasElement, canvasLabel, itemTitle, fullyInView, description, multipage]);

    if (description) {
        return (<span style={{
            display: 'none'
        }} id={descriptionId} ><SanitizedHtml ruleset='iiif' htmlString={description}></SanitizedHtml></span>);
    } else {
        return null
    }
}

function imageFullyInView(osd) {
    if (!(osd?.current?.source && osd?.current?.viewport)) return null;
    const {source, viewport} = osd.current;
    const containerSize = viewport.getContainerSize();
    const topLeftCorner = viewport.imageToViewerElementCoordinates(new OpenSeadragon.Point(1,1));
    const bottomRightCorner = viewport.imageToViewerElementCoordinates(source.dimensions);

    return (topLeftCorner.x >= 0 && topLeftCorner.y >= 0
        && bottomRightCorner.x <= containerSize.x && bottomRightCorner.y <= containerSize.y);
}

function getMetadata(manifest, property) {
    return manifest?.json?.metadata?.filter(item => item.label === property)?.[0]?.value;
}

const mapStateToProps = (state, { windowId }) => {
    const sequence = getSequence(state, {windowId});
    const canvas = getCurrentCanvas(state, {sequence, windowId});
    const manifestId = state.windows[windowId]?.manifestId;
    const manifest = getManifest(state, {windowId, manifestId});
    const manifestTitle = getManifestTitle(state, {windowId, manifestId});
    const osd = OSDReferences.get(windowId);
    const canvasElement = osd?.current?.canvas?.querySelector('canvas');
    const fullyInView = imageFullyInView(osd);
    const multipage = (getCanvases(state, {windowId})?.length || 0) > 1;

    const itemTitle = getMetadata(manifest, 'Title') || manifestTitle;
    let canvasLabel = canvas?.getDefaultLabel();
    if (canvasLabel === itemTitle) canvasLabel = (canvas?.index || 0) + 1;
    const description = getMetadata(manifest, 'Description')

    return { canvas, canvasLabel, itemTitle, canvasElement, fullyInView, description, multipage};
};

export default {
    target: 'OpenSeadragonViewer',
    mode: 'add',
    name: 'EnhancedOsdLabelPlugin',
    component: connect(mapStateToProps)(EnhanceDescription),
};